document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector('.custom-plp-collection-list-ul');
  const indicator = document.querySelector('.custom-scroll-indicator');

  if (wrapper && indicator) {
    const hideArrowOnScroll = () => {
      if (wrapper.scrollLeft > 10) {
        indicator.classList.add('hidden');
      }
    };

    wrapper.addEventListener('scroll', hideArrowOnScroll, { passive: true });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const desc = document.getElementById("coll-description-inner");
  const toggle = document.getElementById("coll-description-toggle");

  if (!desc || !toggle) return;

  // Use em-based max height as defined in CSS
  const maxHeightEm = window.innerWidth <= 468 ? 4.6 : 6.3;
  const fontSize = parseFloat(getComputedStyle(desc).fontSize); // get px value of 1em
  const maxHeightPx = maxHeightEm * fontSize;

  // Allow layout to complete before checking height
  requestAnimationFrame(() => {
    const isOverflowing = desc.scrollHeight > maxHeightPx + 1; // +1px buffer

    if (isOverflowing) {
      toggle.style.display = "inline-block";
      desc.style.maxHeight = `${maxHeightEm}em`;

      toggle.addEventListener("click", function () {
        const expanded = desc.classList.toggle("expanded");
        toggle.textContent = expanded ? "Read less" : "Read more";
        desc.style.maxHeight = expanded ? "none" : `${maxHeightEm}em`;
      });
    } else {
      toggle.style.display = "none";
    }
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   const showBtn = document.querySelector('.custom-show-filter-btn');
//   const hideBtn = document.querySelector('.custom-hide-filter-btn');
//   const toggleBtn = document.querySelector('.custom-filter-toggle-btn');
//   const activeFacets = document.querySelector('.active-facets.active-facets-desktop');

//   if (!showBtn || !hideBtn || !toggleBtn || !activeFacets) return;

//   // Show Filters Click
//   showBtn.addEventListener('click', function () {
//     toggleBtn.classList.add('jci-hide');
//     activeFacets.classList.remove('jci-hide');
//     showBtn.style.display = 'none';
//   });

//   // Hide Filters Click
//   hideBtn.addEventListener('click', function () {
//     toggleBtn.classList.remove('jci-hide');
//     activeFacets.classList.add('jci-hide');
//     showBtn.style.display = 'inline-block';
//   });
// });

jQuery(document).ready(function($) {
  // $('.template-collection .custom-hide-filter-btn').click();

  let isCollectionPg = $('body').hasClass('template-collection');

  
  
})